export const visit = (vm, at) => {
vm(require("foundations-components/lang/ro.lyaml"));
at({ "ro": { "placeholder": "substituent" } });
};